export default __webpack_public_path__ + "guide--vector-tiles-standards-cw-480-b56acbbbd1e5fa9a4ac169409f28fc38.webp";